import { combineReducers } from 'redux';
import auth_code from './reducers/auth_code';
import bookmarks from './reducers/bookmarks';
import content from './reducers/content';
import current_user from './reducers/current_user';
import customer from './reducers/customer';
import markup from './reducers/markup';
import membership from './reducers/membership';
import notifications from './reducers/notifications';
import print from './reducers/print';
import search from './reducers/search';
import section from './reducers/section';
import notes_control_panel from './reducers/notes_control_panel';
import terms from './reducers/terms';
import currentTerm from './reducers/current_term';
import current_note from './reducers/current_note';
import offline from './reducers/offline';
import manage_content from 'reducers/manage_content';
import requestQueue, * as fromRequestQueue from './reducers/request_queue';

import { reducer as loader } from './loader';
import { routerReducer as routing } from 'react-router-redux';
import { reducer as fetchTree } from 'fetch-tree';
import auralNotification from 'reducers/aural_notification';
import skipLink from 'reducers/skip_link';

export default combineReducers({
    notes_control_panel,
    auth_code,
    bookmarks,
    content,
    current_user,
    current_note,
    customer,
    markup,
    membership,
    notifications,
    print,
    search,
    section,
    terms,
    currentTerm,
    loader,
    routing,
    offline,
    requestQueue,
    fetchTree,
    manage_content,
    auralNotification,
    skipLink,
});

export const selectNextRequest = state =>
    fromRequestQueue.selectNextRequest(state.requestQueue);



// WEBPACK FOOTER //
// ./src/root_reducer.js